<template>
  <v-card class="elevation-0 transparent">
    <v-card-text class="ma-0 pa-0">
      <v-row>
        <v-col cols="12" sm="12" md="8" lg="8">
          <v-card>
            <v-card-text>
              <CampaignFunnel :value="allTimePerformance" />
            </v-card-text>
          </v-card>
        </v-col>
         <v-col cols="12" sm="12" md="4" lg="4">
          <v-card>
            <v-card-text>
              <CampaignBrowserDistribution :value="browserDistribution" />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="8" lg="8">
          <v-card>
            <v-card-text>
              <CampaignDailyPerformance :value="dailyPerformance" />
            </v-card-text>
          </v-card>
        </v-col>
       
        <v-col cols="12" sm="12" md="4" lg="4">
          <v-card>
            <v-card-text>
              <CampaignLocaleDistribution :value="localeDistribution" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>


<script>
import CampaignFunnel from "@/components/molecules/campaign/analytics/CampaignFunnel.vue";
import CampaignDailyPerformance from "@/components/molecules/campaign/analytics/CampaignDailyPerformance.vue";

import { CampaignAPIInstance } from "@/api";
import CampaignBrowserDistribution from "@/components/molecules/campaign/analytics/CampaignBrowserDistribution.vue";
import CampaignLocaleDistribution from "@/components/molecules/campaign/analytics/CampaignLocaleDistribution.vue";

export default {
  name: "CampaignAnalytics",
  components: {
    CampaignFunnel,
    CampaignDailyPerformance,
    CampaignBrowserDistribution,
    CampaignLocaleDistribution,
  },
  props: {
    modelValue: {
      type: Array,
      default: () => [{}],
    },
  },
  emits: ["update:modelValue"],

  data() {
    return {
      dailyPerformance: [],
      allTimePerformance: [],
      browserDistribution: [],
      localeDistribution: [],
    };
  },
  computed: {},
  watch: {
    modelValue: {
      handler(newVal) {
        if (newVal) {
          this.getAnalytics();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getAnalytics();
  },

  methods: {
    async getAnalytics() {
      await Promise.all([
        this.getDailyPerformance(),
        this.getAllTimePerformance(),
        this.getBrowserDistributionData(),
        this.getLocaleDistributionData(),
      ]);
    },

    async getDailyPerformance() {
      if (!this.modelValue || !this.modelValue.id) return;
      const { data } = await CampaignAPIInstance.Analytics.last7DaysPerformance(
        this.modelValue.code
      );
      this.dailyPerformance = data;
    },
    async getAllTimePerformance() {
      if (!this.modelValue || !this.modelValue.id) return;
      const { data } = await CampaignAPIInstance.Analytics.allTimePerformance(
        this.modelValue.code
      );
      this.allTimePerformance = data;
    },

    async getBrowserDistributionData() {
      if (!this.modelValue || !this.modelValue.id) return;
      const { data } = await CampaignAPIInstance.Analytics.browserDistribution(
        this.modelValue.code
      );
      this.browserDistribution = data;
    },
    async getLocaleDistributionData() {
      if (!this.modelValue || !this.modelValue.id) return;
      const { data } = await CampaignAPIInstance.Analytics.localeDistribution(
        this.modelValue.id
      );
      this.localeDistribution = data;
    },
  },
};
</script>